import Head from "next/head";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useMemo } from "react";
import Footer from "./footer";
import Header from "./header";
import { getDeliveryCityData } from "../../../redux/action-creaters/location";
import Popups from "../../popups";

export default function CartLayout({
  children,
  scripts,
  isIndex = true,
  host = "",
}) {
  const { title, description, yandexTag, googleTag } = useSelector(
    (state) => state.meta,
  );
  const { cityName, deliveryCityData, deliveryCityDataLoaded } = useSelector(
    (state) => state.location,
  );
  const deliveryCity = useMemo(() => {
    if (
      deliveryCityData?.region === "Ленинградская" ||
      deliveryCityData?.region === "Санкт-Петербург"
    ) {
      return "Санкт-Петербург";
    }
    if (
      deliveryCityData?.region === "Московская" ||
      deliveryCityData?.region === "Москва"
    ) {
      return "Москва";
    }
    return cityName;
  }, [cityName, deliveryCityData]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDeliveryCityData());
  }, [deliveryCityDataLoaded, deliveryCity]);

  return (
    <html lang="ru">
      <Head>
        <link rel="preload" as="image/svg+xml" href="icons.svg" />
        {title && <title>{title}</title>}
        {description && (
          <meta name="description" content={description} key="desc" />
        )}
        <link rel="shortcut icon" href="/favicon.ico" type="image/png" />
        <meta
          httpEquiv="Content-Type"
          content="text/html; charset=UTF-8"
        ></meta>
        <meta name="viewport" content="width=device-width, user-scalable=no" />
        <meta name="robots" content={isIndex ? "index, follow" : "noindex"} />
        {title && <meta property="og:title" content={title} />}
        <meta property="og:type" content="article" />
        <meta property="og:image" content={"/logo2.svg"} />
        {yandexTag && (
          <meta name="yandex-verification" content={yandexTag}></meta>
        )}
        {googleTag && (
          <meta name="google-site-verification" content={googleTag}></meta>
        )}
      </Head>
      <Header />
      {children}
      <Footer host={host} />
      <Popups />

      <div dangerouslySetInnerHTML={{ __html: scripts }} />
    </html>
  );
}
